
export default "/assets/arrow-right-end-on-rectangle-micro.4d984e05.svg"